import React from "react";

import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../assets/Icons";
import FieldForceTxnRequestViewAll from "../../../containers/FieldForceRequest/FieldForceRequestViewAll";
import FieldForceRequestViewAll from "../../../containers/FieldForceRequest/FieldForceRequestViewAll";

const FieldForceRequestViewAllPopup = ({
  closeFfTxnDetailsModal,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
}) => {
  return (
    <div>
      <LargePopupRedirect
        headerTitle="Request history"
        headersubtext="All requests related to the field force account are listed below."
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeFfTxnDetailsModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <FieldForceRequestViewAll
          type={type}
          TxnHistoryid={TxnHistoryid}
          TxnHistoryAccountName={TxnHistoryAccountName}
          categoryName={categoryName}
          closeFfTxnDetailsModal={closeFfTxnDetailsModal}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default FieldForceRequestViewAllPopup;
